import { __assign, __rest } from "tslib";
import React from 'react';
import { cnRadiobox as cn } from '../Radiobox';
import './Radiobox-Box.css';
export var RadioboxBox = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React.createElement("span", __assign({}, props, { className: cn('Box', null, [className]) }), children));
};
